export default "__VITE_ASSET__C9xjG_9A__"